import React, { Component } from "react";
import { Tag, notification, Space } from "antd";
import {
  PlusOutlined,
  EditOutlined,
  StopOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";
import { ButtonItem, SegmentedItem } from "../../../../Components/Items";
import TableItemDinamico from "../../../../Components/TableItemDinamico";
import ModalCampoLead from "../Components/ModalCampoLead";
import axios from "axios";
import { connect } from "react-redux";

const TIPOS_LABEL = {
  text: "Texto",
  number: "Número",
  date: "Fecha",
  boolean: "Verdadero/Falso",
  select: "Lista Desplegable",
};

class ConfiguracionCamposLead extends Component {
  state = {
    campos: [],
    loading: false,
    totalRecords: 0,
    valorFiltro: 2, // 1: Activos, 0: Inactivos, 2: Todos
    modalVisible: false,
    campoAEditar: null,
  };

  fetchData = (params) => {
    this.setState({ loading: true });

    axios
      .post(
        "camposLead/selectCamposLead",
        { ...params, empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            campos: res.data.data,
            totalRecords: res.data.totalRecords,
          });
        } else {
          notification.error({
            message: "Error",
            description: res.data.message || "No se pudieron cargar los campos.",
          });
        }
      })
      .catch((error) => {
        console.error("Error al cargar campos personalizados:", error);
        notification.error({
          message: "Error de conexión",
          description: "Ocurrió un problema de red al cargar la lista.",
        });
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  abrirModalNuevo = () => {
    this.setState({ modalVisible: true, campoAEditar: null });
  };

  abrirModalEditar = (campo) => {
    this.setState({ modalVisible: true, campoAEditar: campo });
  };

  cerrarModal = () => {
    this.setState({ modalVisible: false, campoAEditar: null });
  };

  onExitoModal = () => {
    this.cerrarModal();
    if (this.tableRef) this.tableRef.fetchData?.();
  };

  toggleEstado = (campo) => {
    const nuevoEstado = campo.estado ? 0 : 1;
    axios
      .post(
        "camposLead/cambiarEstadoCampoLead",
        { _id: campo._id, estado: nuevoEstado },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState(
            (prevState) => ({
              campos: prevState.campos.map((c) =>
                c._id === campo._id ? { ...c, estado: nuevoEstado } : c,
              ),
            }),
            () => {
              notification.success({
                message: `Campo ${nuevoEstado ? "Habilitado" : "Deshabilitado"}`,
              });
            },
          );
        } else {
          notification.error({ message: res.data.message });
        }
      })
      .catch((err) => {
        console.error(err);
        notification.error({ message: "Error al cambiar el estado." });
      });
  };

  render() {
    const columnas = [
      {
        title: "Nombre del Campo",
        dataIndex: "nombre",
        buscar: "nombre",
        width: "25%",
        ellipsis: true,
      },
      {
        title: "Tipo",
        dataIndex: "tipo",
        width: "15%",
        render: (tipo) => <Tag color="blue">{TIPOS_LABEL[tipo] || tipo}</Tag>,
      },
      {
        title: "Opciones",
        dataIndex: "opciones",
        width: "30%",
        render: (opciones, record) =>
          record.tipo === "select" && opciones?.length > 0 ? (
            <Space wrap style={{ maxWidth: 320 }}>
              {opciones.map((op, i) => (
                <Tag key={i}>{op}</Tag>
              ))}
            </Space>
          ) : (
            "-"
          ),
      },
      {
        title: "Estado",
        dataIndex: "estado",
        width: "10%",
        render: (estado) =>
          estado ? (
            <Tag color="green">Activo</Tag>
          ) : (
            <Tag color="red">Inactivo</Tag>
          ),
      },
      {
        title: "Acciones",
        dataIndex: "acciones",
        width: "10%",
        align: "center",
        render: (text, record) => (
          <Space>
            <ButtonItem
              size="small"
              icon={<EditOutlined />}
              onClick={() => this.abrirModalEditar(record)}
              tooltip="Editar campo"
            />
            <ButtonItem
              rojo={record.estado}
              verde={!record.estado}
              size="small"
              icon={record.estado ? <StopOutlined /> : <CheckCircleOutlined />}
              onClick={() => this.toggleEstado(record)}
              tooltip={record.estado ? "Deshabilitar Campo" : "Habilitar Campo"}
            />
          </Space>
        ),
      },
    ];

    return (
      <div>
        <ModalCampoLead
          visible={this.state.modalVisible}
          campoAEditar={this.state.campoAEditar}
          empresaId={this.props.empresaId}
          onCancel={this.cerrarModal}
          onExito={this.onExitoModal}
        />

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 10,
            alignItems: "center",
            marginBottom: 12,
          }}
        >
          {window.innerWidth > 1000 && (
            <>
              <SegmentedItem
                options={[
                  { label: "Activos", value: 1 },
                  { label: "Inactivos", value: 0 },
                  { label: "Todos", value: 2 },
                ]}
                onChange={(value) => {
                  if (this.tableRef) {
                    this.tableRef.updateExternalFilters({ estado: value });
                  }
                  this.setState({ valorFiltro: value });
                }}
                value={this.state.valorFiltro}
              />
              <div
                style={{
                  borderLeft: "1px solid #d9d9d9",
                  height: "24px",
                  margin: "0 5px",
                }}
              />
            </>
          )}
          <ButtonItem
            azul
            icon={<PlusOutlined />}
            className="botonAgregar"
            onClick={this.abrirModalNuevo}
          >
            Nuevo Campo
          </ButtonItem>
        </div>

        <TableItemDinamico
          onRef={(node) => (this.tableRef = node)}
          columns={columnas}
          dataSource={this.state.campos}
          loading={this.state.loading}
          totalRecords={this.state.totalRecords}
          onFetchData={this.fetchData}
          rowKey="_id"
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ConfiguracionCamposLead);
